import React from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { Sheet, SheetContent } from '@/components/ui/sheet';
import { X, Download } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useIsMobile } from '@/hooks/use-mobile';
interface Conversation {
  speaker: 'Business' | 'Lead';
  text: string;
}
interface AudioTranscriptModalProps {
  isOpen: boolean;
  onClose: () => void;
  transcript: readonly Conversation[] | Conversation[];
}
const AudioTranscriptModal: React.FC<AudioTranscriptModalProps> = ({
  isOpen,
  onClose,
  transcript
}) => {
  const isMobile = useIsMobile();
  const handleDownloadCSV = () => {
    // Convert transcript to CSV format
    const csvContent = ['Speaker,Text', ...transcript.map(item => `${item.speaker},"${item.text.replace(/"/g, '""')}"`)].join('\n');

    // Create a blob and download link
    const blob = new Blob([csvContent], {
      type: 'text/csv;charset=utf-8;'
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', 'transcript.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const content = <>
      <div className="flex items-center justify-between border-b pb-4">
        <h2 className="text-2xl font-medium">Audio Transcript</h2>
        
      </div>
      <div className="py-4 max-h-[60vh] overflow-y-auto">
        <div className="bg-gray-100 rounded-lg p-6 space-y-6">
          {transcript.map((item, index) => <div key={index} className="space-y-1">
              <div className="font-semibold">{item.speaker}:</div>
              <div>{item.text}</div>
            </div>)}
        </div>
      </div>
      <div className="flex justify-end pt-2">
        <Button onClick={handleDownloadCSV} className="bg-black hover:bg-gray-800 text-white">
          <Download className="mr-2 h-5 w-5" />
          Download CSV
        </Button>
      </div>
    </>;
  if (isMobile) {
    return <Sheet open={isOpen} onOpenChange={open => !open && onClose()}>
        <SheetContent side="bottom" className="h-[90vh] pt-6 px-6">
          {content}
        </SheetContent>
      </Sheet>;
  }
  return <Dialog open={isOpen} onOpenChange={open => !open && onClose()}>
      <DialogContent className="sm:max-w-[600px] p-6">
        {content}
      </DialogContent>
    </Dialog>;
};
export default AudioTranscriptModal;